/* eslint-disable no-unused-vars */
import axios from 'axios'

export const state = {
  token: null,
}

export const actions = {
  // Quitamos init y validate porque no existen / no se usan
  // init({ dispatch }) {
  //   dispatch('validate')
  // },

  async logIn({ commit, getters }, { email, password } = {}) {
    try {
      let url = 'https://admin.abrageo.abracol.co/ABRAGEO/loginAppUser'
      // let url = 'http://localhost:3004/ABRAGEO/loginAppUser'
      let values = { email, pwd: password }

      let result = await axios.post(url, values)

      // Guardar info en localStorage
      localStorage.setItem('user', JSON.stringify(result.data.user))
      localStorage.setItem('zona', JSON.stringify(result.data.zona))
      localStorage.setItem('profile', JSON.stringify(result.data.profile))
      localStorage.setItem('pais', JSON.stringify(result.data.pais))

      // Guardar token en Vuex
      commit('SET_CURRENT_USER', result.data.token)

      // Devolvemos los datos al componente (login.vue)
      return result.data
    } catch (error) {
      console.log(error)
      return 'error'
    }
  },
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.token = newValue
    localStorage.setItem('auth.currentUser', JSON.stringify(newValue))
  }
}

export const getters = {
  loggedIn: (state) => !!state.token,
  token: (state) => state.token
}
